var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"our-services__container"},[_c('div',{staticClass:"services-info"},[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('routes.services.heading')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }